// extracted by mini-css-extract-plugin
module.exports = {"navbar":"navbar-module--navbar--8fnkJ","navbarContainer":"navbar-module--navbar-container--3gIxo","brand":"navbar-module--brand--3zE64","links":"navbar-module--links--3hd-k"};